import { BrowserRouter, Routes, Route } from "react-router-dom";
import MCMWebsite from "./MCM";
import { MentionsLegales, PolitiqueConfidentialite } from "./LegalPages";
import AuditPage from "./AuditPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MCMWebsite />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
